import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useState } from 'react';
import { clsx } from 'clsx';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var MenuLink = function MenuLink(_ref) {
  var link = _ref.link;
  var adornment = link.adornment;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isHovered = _useState2[0],
    setIsHovered = _useState2[1];
  var textColor = 'dark:tw-text-neutral-light-100 tw-text-neutral-light-800';
  var hoveredColor = 'dark:hover:tw-text-secondary-light-500 hover:tw-text-primary-light-500';
  var text = isHovered ? hoveredColor : textColor;
  var iconBaseColor = 'dark:tw-text-neutral-dark-500 tw-text-neutral-light-700';
  var iconHoveredColor = 'dark:tw-text-neutral-dark-500 tw-text-neutral-light-700';
  var iconColor = isHovered ? iconHoveredColor : iconBaseColor;
  var bgColor = 'dark:tw-bg-neutral-dark-700 tw-bg-neutral-light-200';
  return /*#__PURE__*/_jsxs("a", {
    href: link.url,
    className: clsx('tw-flex tw-items-center tw-px-0.8 tw-py-0.8 tw-cursor-pointer tw-w-full tw-rounded-0.8', isHovered ? bgColor : '', text),
    target: link.openInNewTab ? '_blank' : undefined,
    rel: "noopener noreferrer",
    onMouseOver: function onMouseOver() {
      return setIsHovered(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setIsHovered(false);
    },
    onFocus: function onFocus() {
      // Empty function to fix eslint warning
    },
    children: [/*#__PURE__*/_jsx("span", {
      className: "tw-font-link1",
      children: link.label
    }), adornment && /*#__PURE__*/_jsx("div", {
      className: "tw-ml-0.8",
      children: /*#__PURE__*/_jsx(adornment.icon, {
        size: 20,
        className: iconColor
      })
    })]
  }, link.key);
};
export default MenuLink;